import styled from 'styled-components';
import { media } from '@/styles/Qtheme.ts';

export const CDrawerSection = styled.div<{ display?: string }>`
  top: 50px;
  position: absolute;
  left: 0;
  width: 420px;
  height: 60%;
  z-index: 19999 !important;

  transform: translateX(0);
  transition: transform 0.3s ease-out;

  /* 트리거와 Drawer 사이 마우스 이동 시 닫힘 방지용 투명 영역 */
  &::before {
    content: '';
    position: absolute;
    top: -50px;
    left: 0;
    width: 100%;
    height: 50px;
    background: transparent;
  }

  //overflow-y: auto; /* Drawer 내부 스크롤 활성화 */
  @media ${media.mobile} {
    width: 95%;
    top: 50px;
    height: 100%;
    top: 50px;
  }
`;

export const DrawerHeaderSection = styled.div`
  display: flex;
  height: 34px;
  width: 100%;
  justify-content: space-between;
  align-items: center;
  padding: 0 16px;
`;

export const DrawerCloseIcon = styled.button`
  background-color: transparent;
  border: none;
  border-radius: 50px;
  padding: 5px;
  cursor: pointer;
  &:hover {
    background-color: ${(props) => props.theme.COLORS.gray};
  }
`;
